/* global __webpack_public_path__ */
import JSX, {Component, render, h} from 'preact'
import qs from 'qs'
import 'preact/debug' // condition in this file prevents it from usage outside of dev env
import tracker from '../components/tracker/publish'
import detectLogout from '../utils/detectLogout'
import initializeDelightedSurvey from '../utils/initializeDelightedSurvey'
import globals, { publish } from '../utils/globals'
import { addTranslationDict } from './translationsUtils/translations'
import loadScript from 'load-script'

import axios from 'axios'

declare var __webpack_public_path__: string
declare var require: (module: string) => any
declare var       module: {
  hot?: {
    accept: (cb: () => void) => void
  }
}

declare global {
  interface Window {
    insided: any,
    inSided: any,
    _babelPolyfill: {}
    hljs: {
      highlightBlock(el: Element): void
    }
  }
}

let csrfToken: string = ''

const csrfElement: HTMLInputElement | null = document.querySelector('input#csrftoken')
if (csrfElement !== null) {
  csrfToken = csrfElement.value
}

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN': csrfToken
}

if (typeof window.CustomEvent !== 'function') require('../utils/customEventPolyfill')
if (!window._babelPolyfill) require('@babel/polyfill')
// eslint-disable-next-line no-undef
if (typeof NodeList.prototype.forEach !== 'function') {
  require('../utils/forEachPolyfill').default()
}

detectLogout()

var scriptElement = document.getElementById('insided-preact-app')
if (scriptElement) {
  globals('region', scriptElement.getAttribute('data-region') || '')
  globals('environment', scriptElement.getAttribute('data-environment') || '')
  globals('communityId', scriptElement.getAttribute('data-communityId') || '')
  globals('cssLink', scriptElement.getAttribute('data-cssLink') || '')
  globals('cssVariables', document.getElementById('css-variables')?.innerHTML || '')
  globals('communityUrl', scriptElement.getAttribute('data-communityUrl') || '')
  globals('controlUrl', scriptElement.getAttribute('data-controlUrl') || '')
  globals('application', scriptElement.getAttribute('data-application') || '')
  globals('communityLanguage', document.getElementsByTagName('html')[0].getAttribute('lang') || '')
  globals('defaultCdn', scriptElement.getAttribute('data-defaultCdn') || '')
  globals('facebookAppId', scriptElement.getAttribute('data-fb-app-id') || '')
  globals('eventLogger', scriptElement.getAttribute('data-eventLogger') || '')
  globals('communityLanguage', scriptElement.getAttribute('data-language') || '')

  const basePath = scriptElement.getAttribute('data-basepath' || '')

  if (basePath) {
    globals('basePath', basePath.replace(/\/js\/$/, '/'))
    __webpack_public_path__ = basePath.replace(/\/js\/$/, '/') // eslint-disable-line
  } else {
    globals('basePath', '')
  }
  let activeModules = scriptElement.getAttribute('data-modules') || ''
  try {
    activeModules = JSON.parse(activeModules)
    globals('activeModules', activeModules)
  } catch (e) {
    globals('activeModules', [])
  }
}

if (globals('application') === 'control') {
  initializeDelightedSurvey()

  if(window.sessionStorage.getItem('UserLoggedInControl')) {
    tracker.trackEvent('userevent', {
      type: '[Control] User Visited',
      user_id: window.inSidedData.user.userid,
      user_email: window.inSidedData.user.email,
      user_name: window.inSidedData.user.name,
      user_primary_role: window.inSidedData.user.mainRole,
      user_custom_roles: window.inSidedData.user.role,
    })
    window.sessionStorage.removeItem('UserLoggedInControl')
  }
}

interface ComponentParams {
  phrases?: {}
  translations?: {}
  parentEl?: HTMLElement
}

export function initialiseComponent (componentName: string, el: HTMLElement, params: ComponentParams, unrender = false) {
    const child = el.firstChild as Element  // preact render() also accepts text Nodes as third argument
    if (unrender) {
      render('', el, child)
      return
    }
    let LoadedComponent: typeof Component
    try {
      LoadedComponent = require('preact-components/' + componentName + '.js').default
    } catch (err) {
      if (err.code !== 'MODULE_NOT_FOUND') throw err
      LoadedComponent = require('preact-components/' + componentName + '.tsx').default
    }
    addTranslationDict(params.phrases || params.translations)
    params.parentEl = el
    if (!LoadedComponent) return
    render(<LoadedComponent {...params} />, el, child)
    if (module.hot) {
      module.hot.accept(() => {
        try {
          LoadedComponent = require('preact-components/' + componentName + '.js').default
        } catch (err) {
          if (err.code !== 'MODULE_NOT_FOUND') throw err
            LoadedComponent = require('preact-components/' + componentName + '.tsx').default
        }
        render(<LoadedComponent {...params} />, el, child)
      })
    }
  }

window.insided = {
  initialiseComponent,
  trackEvent: tracker.trackEvent,
  publish: publish
}

function highlightCodeBlocks (wrapperComponent: HTMLElement) {
  const codeComponentsToHighlight = wrapperComponent.querySelectorAll('pre code')
  if (codeComponentsToHighlight.length) {
    let link = document.createElement('link')
    link.href = __webpack_public_path__ + 'ckeditor/plugins/codesnippet/lib/highlight/styles/github.css'
    link.rel = 'stylesheet'
    document.head.appendChild(link)

    loadScript(__webpack_public_path__ + 'ckeditor/plugins/codesnippet/lib/highlight/highlight.pack.js', () => {
      codeComponentsToHighlight.forEach((block) => {
        window.hljs.highlightBlock(block)
      })
    })
  }
}

function prepareSpoilersAndQuotes (wrapperComponent: Element) {
  wrapperComponent.querySelectorAll('content-spoiler, content-quote').forEach((content: Element) => {
    if (!content.getAttribute('data-prepared')) {
      let el = document.createElement('div')
      let childrenWrapper = document.createElement('div')
      childrenWrapper.className = content.tagName.toLowerCase()
      while (content.firstChild) {
        const el = content.removeChild(content.firstChild)
        childrenWrapper.appendChild(el)
      }
      content.appendChild(el)
      content.appendChild(childrenWrapper)

      content.setAttribute('data-prepared', 'true')
    }
  })
}

export function isHtmlElement(el: EventTarget | null): el is HTMLElement {
  return !!el && 'dataset' in el
}

export function isInputEl(el: EventTarget| null): el is HTMLInputElement {
  return !!el && 'value' in el
}

export function isChangeEvent(e: Event): e is ChangeEvent {
  return !!e.target && 'value' in e.target
}

export function isInputClickEvent(e: Event): e is ClickEvent<HTMLInputElement> {
  return !!e.target && 'value' in e.target
}

export function isFunction (child: JSX.Element): child is Function {
  return typeof child === 'function'
}

export function instantiatePreactComponents (wrapperComponent: HTMLElement) {
  let components = wrapperComponent.querySelectorAll('[data-preact], user-mention, content-quote, content-spoiler, oembed')

  for (let el of components) {
    if (!isHtmlElement(el)) continue
    try {
      window.insided.initialiseComponent(
        el.dataset.preact || (el.tagName.toLowerCase() + '/index'),
        el,
        el.dataset.props ? JSON.parse(el.dataset.props) : { ...el.dataset, content: el.innerHTML }
      )
    } catch (error) {
      console.log(error)
    }
  }
}

function addGlobalPublishers () {
  document.querySelectorAll('[data-trigger]').forEach(element => {
    if (!isHtmlElement(element)) return
    element.addEventListener('click', (e) => {
      e.preventDefault()
      if (element.dataset.trigger === 'quote') {
        if (!element.dataset.username) return
          publish('quote', {
            username: element.dataset.username,
            content: element.dataset.content || ''
          })
      }
    })
  })
}

/*
  Dynamically requires components from HTML elements
  Usage example:
  <div
    data-preact="content-helpfulness/ContentHelpfulnessManager"
    data-props="{{ configuration | json_encode }}">
  </div>
 */

export const bindPreactComponents = (wrapperComponent: HTMLElement) => {
  prepareSpoilersAndQuotes(wrapperComponent)

  wrapperComponent.querySelectorAll('oembed')
  .forEach((content: Element) => {
    if (!isHtmlElement(content)) return
    content.dataset.url = content.getAttribute('url') || ''
  })

  instantiatePreactComponents(wrapperComponent)

  highlightCodeBlocks(wrapperComponent)
}

window.insided.bindPreactComponents = bindPreactComponents

window.insided.bindPreactComponents(document)

addGlobalPublishers()

const searchQuery = window.location.search
const queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })
if (queryParameters.postid) window.location.hash = '#post' + queryParameters.postid
